import { render, staticRenderFns } from "./TableCategory.vue?vue&type=template&id=e403f42a"
import script from "./TableCategory.vue?vue&type=script&lang=js"
export * from "./TableCategory.vue?vue&type=script&lang=js"
import style0 from "./TableCategory.vue?vue&type=style&index=0&id=e403f42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports